import { Injectable } from '@angular/core';
import { ApiLegacyService } from '../../../services/api/api.service';
import { ProjectElement } from '../../../resources/element/project-element.interface';
import { ElementLog } from './element-log.interface';
import { ElementLogStore } from './element-log-store';

@Injectable({
  providedIn: 'root'
})
export class ElementLogService {

  constructor(
    private api: ApiLegacyService,
    private elementLogStore: ElementLogStore
  ) { }

  /**
   * Add comment.
   *
   * @param element Element to add the comment to.
   * @param value The comment text.
   */
  public addComment(element: ProjectElement, value: ElementLog['text']) {
    const comment = {
      elementId: element._id,
      moduleId: element.moduleId,
      submoduleId: element.submoduleId,
      text: value
    } as ElementLog;

    this.elementLogStore.insert(comment);
  }

  /**
   * Get element logs.
   *
   * @param element The element to get the logs for.
   * @returns Element logs as an API response.
   */
  public open(element): void {
    this.api.getElementLogs(element).subscribe(data => {
      this.elementLogStore.set(data.logs);
    });
  }

}
